import { render, staticRenderFns } from "./ParcelTransportDocumentsSection.vue?vue&type=template&id=4402ce63&scoped=true&"
import script from "./ParcelTransportDocumentsSection.vue?vue&type=script&lang=js&"
export * from "./ParcelTransportDocumentsSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelTransportDocumentsSection.vue?vue&type=style&index=0&id=4402ce63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4402ce63",
  null
  
)

export default component.exports